// extracted by mini-css-extract-plugin
module.exports = {"classSection":"style-module__classSection___1E_WU"};